export default "__VITE_ASSET__67607240__"